import { useState, useEffect } from "react";
import { useRouter } from "next/router";

export function convertBreadcrumbTitle(string: string) {
	const nameOnly = string.includes("-") ? string.split("-").slice(1).join("-") : string;
	const decodedString = decodeURIComponent(nameOnly);
	return decodedString
	  .replace(/-/g, " ")
	  .toLowerCase();
  }
  

export default function useBreadcrumb() {
	const router = useRouter();
	const [breadcrumbs, setBreadcrumbs] = useState<any>(null);

	useEffect(() => {
		if (router) {
			const linkPath = router.asPath.split("/");
			linkPath.shift();

			const pathArray = linkPath.map((path, i) => {
				return {
					breadcrumb: convertBreadcrumbTitle(path),
					href: "/" + linkPath.slice(0, i + 1).join("/"),
				};
			});

			setBreadcrumbs(pathArray);
		}
	}, [router]);

	return breadcrumbs;
}
